import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'rdf-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.css']
})
export class DateInputComponent implements OnInit {
  @Input() field
  constructor() { }

  ngOnInit() {
  }

}
